export default defineNuxtRouteMiddleware((to, from) => {
  const profile = useProfileStore();
  if (!profile.isParent) return;
  if (profile.isASubscriber) return;
  const members = profile?.family?.members || [];

  if (
    members.length === 2 &&
    from.path === '/mon-compte/ajouter-premier-membre'
  ) {
    return navigateTo('/famille/presentation', { redirectCode: 301 });
  }
});
